import type { Shipment } from '../../modules/shipments/types';

/** Minimal field needed to derive a shipment's display label. */
export type ShipmentLabelFields = Partial<Pick<Shipment, 'reference_number'>>;

/**
 * Canonical display label for a shipment: the reference number, or a shared
 * "Untitled shipment" fallback (pass `t('shipments:untitled')`).
 *
 * This is the single source of truth so reference-less shipments read
 * identically across the list, kanban, detail page, and every cross-module
 * linked-shipment display — and we never leak the raw UUID into the UI (IMP-4).
 *
 * The fallback deliberately does NOT use `description`: it isn't carried on
 * every linked-shipment surface (e.g. the PO↔shipment junction exposes only
 * `shipment_reference_number`), so falling back to it would re-introduce the
 * very cross-view inconsistency this helper exists to remove. `reference_number`
 * is the one field present everywhere. Surfaces that want to show the
 * description do so as a separate subtitle, not as the label.
 */
export function getShipmentLabel(
  shipment: ShipmentLabelFields | null | undefined,
  untitledLabel: string,
): string {
  return shipment?.reference_number || untitledLabel;
}
